<template>
<div>
    <div id="page-panel">
        <div class="customer-top-nav">
            <div class="title">
                <span>{{$t('reports.names.'+ reportCode)}}</span><br>
            </div>
        </div>
        <div>
            {{ myInventory.name }}
            <el-autocomplete class="inline-input" :trigger-on-focus="false" value-key="name" v-model="model.item" style="width:100%;" :fetch-suggestions="querySearch" :placeholder="$t('sales_orders.selectProduct')" @select="handleSelect">
                <template slot-scope="{ item }">
                    <ItemTemplate :product="item" :showQty="false" :showInventoryName="false" :inventory="item.inventory" :format="item.format" :volume="item.volume"></ItemTemplate>
                </template>
            </el-autocomplete>
            <el-divider></el-divider>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <ItemTemplate v-if="itemSelected" :product="itemSelected" :showQty="false" :showInventoryName="false" :inventory="itemSelected.inventory" :format="itemSelected.format" :volume="itemSelected.volume"></ItemTemplate>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div id="globalPerformance" style="height:200px;width:100%"></div>
              </el-col>
            </el-row>
            
            <el-divider></el-divider>
            
            <h4>Sommaire de la performance</h4>
            <el-table
                :data="productSummaryPerformance"
                :span-method="objectSpanMethod"
                border
                style="width: 100%;font-size:12px;">
                <el-table-column
                prop="total"
                width="100"
                align="center"
                label="Qte. init.">
                </el-table-column>
                <el-table-column
                prop="totalAdjusted"
                width="100"
                align="center"
                label="Qte. ajustée">
                </el-table-column>
                <el-table-column
                prop="qtyToDate"
                width="100"
                align="center"
                label="Qte. restante">
                </el-table-column>
                <el-table-column
                prop="title"
                width="100"
                label="Type">
                </el-table-column>
                <el-table-column
                align="center"
                label="120 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay120 != null">
                        <span style="margin-left: 10px">{{ scope.row.percent120 }}%({{ scope.row.delay120 }})</span>
                        <span v-if="scope.row.percent120 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent120 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent120  < 80 && scope.row.percent120 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="150 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay150 != null && scope.row.percent120 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent150 }}%({{ scope.row.delay150 }})</span>
                        <span v-if="scope.row.percent150 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent150 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent150  < 80 && scope.row.percent150 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                      </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="180 jours">
                    <template slot-scope="scope">
                        <div v-if="scope.row.delay180 != null && scope.row.percent150 < 100">
                          <span style="margin-left: 10px">{{ scope.row.percent180 }}%({{ scope.row.delay180 }})</span>
                          <span v-if="scope.row.percent180 >= 80"class="mdi mdi-check-circle success-text"></span>
                          <span v-if="scope.row.percent180 < 50" class="mdi mdi-alert-circle danger-text"></span>
                          <span v-if="scope.row.percent180  < 80 && scope.row.percent180 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                        </div>
                        <span v-else>--</span>
                      </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="210 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay210 != null && scope.row.percent180 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent210 }}%({{ scope.row.delay210 }})</span>
                        <span v-if="scope.row.percent210 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent210 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent210  < 80 && scope.row.percent210 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="Hors délais">
                    <template slot-scope="scope">
                      <div v-if="scope.row.overDelay != null && scope.row.percent210 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percentOver }}%({{ scope.row.overDelay }})</span>
                        <span v-if="scope.row.percent210 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent210 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent210  < 80 && scope.row.percentOver >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-divider></el-divider>
            <h4>Performance par lot</h4>
            <el-table
                :data="itemsPerformance"
                border
                style="width: 100%;font-size:12px;">
                <el-table-column
                fixed
                width="180"
                prop="reference"
                label="Lot">
                </el-table-column>
                <el-table-column
                prop="availabilityDate"
                label="Date de mise en dispo">
                <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ formatDate(scope.row.availabilityDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="vintage"
                align="center"
                label="Millésime">
                </el-table-column>
                <el-table-column
                prop="total"
                align="center"
                label="Qte. init.">
                </el-table-column>
                <el-table-column
                prop="totalAdjusted"
                align="center"
                label="Qte. ajustée">
                </el-table-column>
                <el-table-column
                align="center"
                label="120 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay120 != null">
                        <span style="margin-left: 10px">{{ scope.row.percent120 }}%({{ scope.row.delay120 }})</span>
                        <span v-if="scope.row.percent120 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent120 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent120  < 80 && scope.row.percent120 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="150 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay150 != null && scope.row.percent120 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent150 }}%({{ scope.row.delay150 }})</span>
                        <span v-if="scope.row.percent150 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent150 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent150  < 80 && scope.row.percent150 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="180 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay180 != null && scope.row.percent150 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent180 }}%({{ scope.row.delay180 }})</span>
                        <span v-if="scope.row.percent180 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent180 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent180  < 80 && scope.row.percent180 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="210 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay210 != null && scope.row.percent180 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent210 }}%({{ scope.row.delay210 }})</span>
                        <span v-if="scope.row.percent210 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent210 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent210  < 80 && scope.row.percent210 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="Hors délais">
                    <template slot-scope="scope">
                      <div v-if="scope.row.overDelay != null && scope.row.percent210 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percentOver }}%({{ scope.row.overDelay }})</span>
                        <span v-if="scope.row.percentOver >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percentOver < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percentOver  < 80 && scope.row.percentOver >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="qtyToDate"
                align="center"
                label="Qte. restante">
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import InventoryAPI from '@/services/API/inventory'
import ItemTemplate from '@/components/product/item-template-v2'
import dayjs from 'dayjs';
import * as echarts from 'echarts';
export default {
  name : "WineSalesProductPerformance-report",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      pageWidth : null,
      pageHeight : null,
      itemSelected: null,
      model : {
        item: null,
      },
      itemsPerformance: [],
      productSummaryPerformance: [],
    };
  },
  components : {
    ItemTemplate,
  },
  computed : {
    reportCode(){
      return this.$route.params.code;
    },
    myInventory(){
        return _.find(this.inventories, inv => inv.code === 'IP');
    },
    ...mapState('inventory',['inventories']),
  },
  methods : {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex <= 2) {
          if (rowIndex  === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
    initGlobalPerf () {
      console.log('initGlobalPerf');
      var chartDom = document.getElementById('globalPerformance');
      var myChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [
          {
            radius: "100%",
            name: 'Ventes dans les 120 jours',
            type: 'gauge',
            detail: {
              formatter: '{value}'
            },
            data: [
              {
                value: _.get(_.head(this.productSummaryPerformance), 'percent120'),
                name: 'SCORE'
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
    },
    formatDate(date, format = 'YYYY-MM-DD') {
        return dayjs(date).format(format);
    },
    querySearch(queryString, cb){
        return InventoryAPI.fetchProductsV2({ inventoryId: _.get(this.myInventory, 'id'), searchTerms: queryString, paging: 'no', limit:25}, _.get(this.myInventory, 'id'))
          .then(products => {
            cb(products);
          })
    },
    fetchItemsPerformance() {
        InventoryAPI.fetchProductPuidItemsPerformance(_.get(this.itemSelected, 'puid'), _.get(this.myInventory, 'id'), {})
            .then((performance) => {
                this.itemsPerformance = [];
                this.productSummaryPerformance = [];
                const summaryPerformanceCumul = { // cumulatif
                    total: 0,
                    delay120: 0,
                    delay150: 0,
                    delay180: 0,
                    delay210: 0,
                    overDelay: 0,
                    qtyToDate: 0,
                    totalAdjusted: 0,
                }
                const summaryPerformance = {  // par jours délais non cumulatif
                    total: 0,
                    delay120: 0,
                    delay150: 0,
                    delay180: 0,
                    delay210: 0,
                    overDelay: 0,
                    qtyToDate: 0,
                    totalAdjusted: 0,
                }
                _.forEach(performance, p => {
                    
                    const item = _.find(this.itemSelected.items, i => i.id === p.id);
                    summaryPerformanceCumul.total += item.qty;

                    var qty = p.delay120;
                    summaryPerformanceCumul.delay120 += qty;
                    if (p.delay150 != null) {
                      qty = p.delay150;
                    }

                    summaryPerformanceCumul.delay150 += qty;
                    if (p.delay180 != null) {
                      qty = p.delay180;
                    }

                    summaryPerformanceCumul.delay180 += qty;
                    if (p.delay210 != null) {
                      qty = p.delay210;
                    }
                    summaryPerformanceCumul.delay210 += qty;
                    if (p.overDelay != null) {
                      qty = p.overDelay;
                    }
                    
                    summaryPerformanceCumul.overDelay += qty;
                    summaryPerformanceCumul.qtyToDate += _.get(item, 'quantity.onHand');
                    const totalAdjusted =  _.get(item, 'quantity.onHand') + _.get(item, 'quantity.packaged');
                    summaryPerformanceCumul.totalAdjusted += totalAdjusted;
                    
                    this.itemsPerformance.push({
                        id: p.id,
                        reference: p.reference,
                        availabilityDate: p.availabilityDate,
                        vintage: _.get(p, 'extraInfo.vintage'),
                        total: item.qty,
                        totalAdjusted,
                        delay120: p.delay120,
                        percent120: ((p.delay120 / totalAdjusted) * 100).toFixed(0),
                        delay150: p.delay150,
                        percent150: ((p.delay150 / totalAdjusted)* 100).toFixed(0),
                        delay180: p.delay180,
                        percent180: ((p.delay180 / totalAdjusted) * 100).toFixed(0),
                        delay210: p.delay210,
                        percent210: ((p.delay210 / totalAdjusted) * 100).toFixed(0),
                        overDelay: p.overDelay,
                        percentOver: ((p.overDelay / totalAdjusted) * 100).toFixed(0),
                        qtyToDate: _.get(item, 'quantity.onHand'),
                    })
                })
                
                summaryPerformanceCumul.percent120 = ((summaryPerformanceCumul.delay120 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percent150 = ((summaryPerformanceCumul.delay150 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percent180 = ((summaryPerformanceCumul.delay180 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percent210 = ((summaryPerformanceCumul.delay210 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percentOver = ((summaryPerformanceCumul.overDelay / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.title="CUMUL";

                var soldOut = false;
                summaryPerformance.delay120 = summaryPerformanceCumul.delay120;
                if (summaryPerformanceCumul.percent120 === "100") soldOut = true;
                summaryPerformance.delay150 = !soldOut ? summaryPerformanceCumul.delay150 - summaryPerformanceCumul.delay120 : null;
                if (summaryPerformanceCumul.percent150 === "100" || soldOut === true) soldOut = true;
                summaryPerformance.delay180 = !soldOut ? summaryPerformanceCumul.delay180 - summaryPerformanceCumul.delay150 : null;
                if (summaryPerformanceCumul.percent180 === "100"  || soldOut === true) soldOut = true;
                summaryPerformance.delay210 = !soldOut ? summaryPerformanceCumul.delay210 - summaryPerformanceCumul.delay180 : null;
                if (summaryPerformanceCumul.percent210 === "100"  || soldOut === true) soldOut = true;
                summaryPerformance.overDelay = !soldOut ? summaryPerformanceCumul.overDelay - summaryPerformanceCumul.delay210 : null;
                summaryPerformance.totalAdjusted = summaryPerformanceCumul.totalAdjusted;
                summaryPerformance.total = summaryPerformanceCumul.total;

                summaryPerformance.percent120 = ((summaryPerformance.delay120 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percent150 = ((summaryPerformance.delay150 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percent180 = ((summaryPerformance.delay180 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percent210 = ((summaryPerformance.delay210 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percentOver = ((summaryPerformance.overDelay / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.title="BY_DELAY";

                this.productSummaryPerformance.push(summaryPerformance);
                this.productSummaryPerformance.push(summaryPerformanceCumul);
                

                this.initGlobalPerf();
            })
    },
    handleSelect (selectedItem) {
        this.itemSelected = selectedItem;
        //On va fetcher les informations sur la performance des items
        this.fetchItemsPerformance();
        
    },
    setPageWidth() {
        this.pageWidth = document.getElementById('page-panel').offsetWidth;
        this.pageHeight = document.getElementById('page-panel').offsetHeight;
    },
    ...mapActions('inventory',['fetchInventories'])
  },
  mounted(){
    this.setPageWidth();
  },
  beforeDestroy(){
    this.data = [];
  },
  created(){
    this.fetchInventories();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>